// api.js

import axios from "axios";
import { ENV } from "./env";

// const axiosInstance = axios.create({
//   baseURL: ENV.API_URL, // Replace with your API base URL
//   timeout: 5000, // Timeout after 5 seconds
// },headers: {
//   'Content-Type': 'application/json',
//   // Other headers if needed
// });
const axiosInstance = axios.create({
  baseURL: ENV.API_URL, // Example base URL
  timeout: 5000, // Timeout after 5 seconds
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    // Other headers if needed
  }
});

// Optional: Add a request interceptor to include authentication token
axiosInstance.interceptors.request.use(
  (config) => {
    // const token = "dGFuaWFfMjAyNC0wOC0wNg=="; // Replace with your authentication logic
    const token = "dGFuaWFfMjAyNC0wOS0wNQ=="; // Replace with your authentication logic
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
  
);
// Add a response interceptor to handle errors globally
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      // Handle unauthorized access (e.g., redirect to login page)
      console.error("Unauthorized access. Redirecting to login...");
      // Redirect code here
    } if (error.response.status === 404) {
      // Handle unauthorized access (e.g., redirect to login page)
      console.error("Unauthorized access. Redirecting to login...");
      // Redirect code here
    }
    return Promise.reject(error);
  }
);
export default axiosInstance;